import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSkeleton = _resolveComponent("BaseSkeleton")!
  const _component_VBtnAdapted = _resolveComponent("VBtnAdapted")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_BaseSkeleton, _mergeProps({
        key: 0,
        type: "button",
        class: _ctx.classes
      }, _ctx.$attrs), null, 16, ["class"]))
    : (_openBlock(), _createBlock(_component_VBtnAdapted, _mergeProps({
        key: 1,
        depressed: "",
        class: ["base-button", _ctx.classes],
        disabled: _ctx.disabled ? 'disabled' : null
      }, _ctx.$attrs), {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        _: 3
      }, 16, ["class", "disabled"]))
}